import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable, of, Subject } from "rxjs";
import { finalize, map, tap } from "rxjs/operators";

import { SiteService } from "src/app/sites-management/site.service";
import { SiteMenuService } from "src/app/site-menu/site-menu/common/services/site-menu.service";
import { EStatus, ETemplateTypes } from "src/app/models/general-enums";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})
export class PagesService {

    private loaderSubject = new BehaviorSubject<boolean>(false);
    showLoader$: Observable<boolean> = this.loaderSubject.asObservable()

    pagesSubject = new BehaviorSubject<any[]>(null);
    pages$: Observable<any[]> = this.pagesSubject.asObservable();

    archivedPagesSubject = new BehaviorSubject<any[]>(null);
    archivedPages$: Observable<any[]> = this.archivedPagesSubject.asObservable()

    private postsSubject = new BehaviorSubject<any[]>(null);
    posts$: Observable<any[]> = this.postsSubject.asObservable();

    private categoriesSubject = new BehaviorSubject<any[]>(null);
    categories$: Observable<any[]> = this.categoriesSubject.asObservable();

    private menuCategoriesSubject = new BehaviorSubject<any[]>(null);
    menuCategories$: Observable<any[]> = this.menuCategoriesSubject.asObservable();

    private pageTemplatesSubject = new BehaviorSubject<any[]>(null);
    pageTemplates$: Observable<any[]> = this.pageTemplatesSubject.asObservable();

    formSaved = true;

    constructor(
        private http: HttpClient,
         private snotifyService: ToastrService,
        private siteService: SiteService,
        private siteMenuService: SiteMenuService
    ) {
        this.getPageCategory();
        this.getAll().subscribe();

        this.siteService.isSiteChanged$
            .subscribe(
                (res) => this.getAll().subscribe()
            )
    }

    // payload ={Status : 4}
    getAll() {
        this.loaderSubject.next(true);

        return forkJoin([

             //this.http.get('/Categories/GetCategoriesByTypeId/5'),
             //this.http.get('/Categories/GetCategoriesByTypeId/1'),
             
            // this.http.get("/CategoriesApi/GetCategoriesById/5"),
            //this.http.get("/CategoriesApi/GetCategoriesById/1")
            
            this.http.get(`/CategoriesApi/GetCategoriesByTypeId/${ETemplateTypes.Product}`),
            this.http.get(`/CategoriesApi/GetCategoriesByTypeId/${ETemplateTypes.Page}`)
        ]).pipe(
            tap((res: any[]) => {
                if (res && res.length > 0) {
                    const categoreies = res[0].map((element) => { 
                        const categoryId = element.id 
                        return element = {...element , ...element.categoryDetails[0] , id:categoryId}
                    })
                    this.categoriesSubject.next(categoreies);

                    this.menuCategoriesSubject.next(res[1]);
                }
            }),
            // map(res => {
            //     if (res && res.length > 0) {
            //       return res[0].map((res))
            //     }
            //   }),
            finalize(() => this.loaderSubject.next(false))
        )
    }
    getPageCategory() {
        this.pageTemplatesSubject.next(null);
        this.http.get('/PageTemplate/GetAllPageTemplates')
            .pipe(
                tap((templates: any[]) => templates && this.pageTemplatesSubject.next(templates))
            )
            .subscribe()
    }
    getActivePages(data) {
        return this.http.post('/Pages/GetAllPages', data).pipe(
            tap((res: any[]) => {
                this.pagesSubject.next(res);
            }))
    }
    getArchivePages(data) {
        let params = {
            ...data
        }
        params.status = 4
        return this.http.post('/Pages/GetAllPages', params).pipe(
            tap((res: any[]) => {
                this.archivedPagesSubject.next(res);
            }))
    }
    getRelatedPages(parentId: number) {
        this.loaderSubject.next(true);
        return this.http.get(`/Pages/GetRelatedPages/${parentId}`)
            .pipe(
                finalize(() => this.loaderSubject.next(false))
            );
    }

    getMenusByCategoryId(id: number): Observable<any> {
        return this.http.get<any>(`/Menus/GetMenusByCategoryId/${id}/6`)
            .pipe(
                map(res => res.result)
            );
    }

    getMenusByParentPageId(parentId: number): Observable<any> {
        return this.http.get<any>(`/Menus/GetMenuByParentPageId/${parentId}`);
    }

    getPageTemplates() {
        this.pageTemplatesSubject.next(null);
        this.http.get('/PageTemplate/GetAllPageTemplates')
            .pipe(
                tap((templates: any[]) => {
                    if (templates && templates.length > 0) {
                        this.pageTemplatesSubject
                            .next(templates.filter(x => x.type == 1))

                    }
                }
                ))
            .subscribe()
    }

    editPageStatus(ids: string, newStatus: number) {
        return this.http.post('/Pages/UpdatePagesStatus/' + ids + '/' + newStatus, {})
    }

    submitAddEditPage(payload) {

        this.loaderSubject.next(true);
        return this.http.post('/Pages/AddEditPage', payload)
            .pipe(
                finalize(() => this.loaderSubject.next(false))
            );
    }

    savePagesMenu(menus) {
        return this.http.post('/Menus/AddEditMenuForMultiPage', menus).pipe(
            finalize(() => this.siteMenuService.updateMenus())
        );
    }

    setPageAsDefault(slug: string) {
        return this.http.get('/Sites​/SetDefaultPage​/' + slug)
            .subscribe();
    }

    openNotifySuccess(message: any) {
        this.snotifyService.success("", message, {
            timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
        })
    }

    getPageRoles() {
        this.pageTemplatesSubject.next(null);
        this.http.get('/RolesManagement​/GetRoles').subscribe();
    }

    clonePage(SourceParentId, TargetPageId) {
        return this.http.get(`/Pages/ClonePages/SourceParentId/TargetPageId?SourceParentId=${SourceParentId}&TargetPageId=${TargetPageId}`)
    }


    //components
    getAllComponents() {
        return this.http.get(`/Components/GetAllComponents`);
    }
    getSharedElements(cultureId) {
        if (cultureId) {
            return this.http.get(`/Elements/GetSharedElements/` + cultureId);
        } else {
            return this.http.get(`/Elements/GetSharedElements`);

        }
    }

    saveSharedelements(data) {
        if (data.length > 0) {
            return this.http.post("/Elements/ShareElement", data)
        } else {
            return of(null)
        }
    }

    getSharedElementByCode(identifierCode, cultureId) {
        const data = {
            identifierCode: identifierCode,
            cultureId: cultureId
        }
        return this.http.post("/Elements/GetSharedElementByCode", data)
    }

    getAssignedRoles(pageId) {
        return this.http.get(`/General/GetPageAssignedRoles/${pageId}`)
    }
    updateAssignedRoles(payload) {
        console.log('payload');

        console.log(payload);

        return this.http.post('/General/SavePageAssginedRoles', payload)
    }

    updaterequiredLogin(selectedPages, selectLogin) {
        const payload = {
            parentsPageId: selectedPages,
            loginPageId: selectLogin
        }

        return this.http.post('/pages/setloginpage', payload)
    }
}
